import { getPlayersHistory } from "actions/players"
import { useCallback, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectPlayersHistory } from "selectors/players"

import { DetailsList, Slider, Spinner, SpinnerSize } from "@fluentui/react"
import { debounce } from "lodash"

const defaultColumns = [
  {
    key: 'rank',
    name: 'Rank',
    minWidth: 50,
    maxWidth: 50,
    fieldName: 'rank',
    isResizable: false,
  },
  {
    key: 'name',
    name: 'Player',
    minWidth: 125,
    fieldName: 'name',
  },
  {
    key: 'score',
    name: 'Score',
    minWidth: 125,
    maxWidth: 125,
    fieldName: 'current_elo',
    isResizable: false,
  },
  {
    key: 'wins',
    name: 'Wins',
    minWidth: 50,
    maxWidth: 50,
    fieldName: 'wins',
    isResizable: false,
  },
  {
    key: 'losses',
    name: 'Losses',
    minWidth: 50,
    maxWidth: 50,
    fieldName: 'losses',
    isResizable: false,
  },
  {
    key: 'peak',
    name: 'Peak',
    minWidth: 100,
    maxWidth: 100,
    fieldName: 'highest_elo',
    isResizable: false,
  },
  {
    key: 'lastUpdate',
    name: 'Last Update',
    minWidth: 130,
    maxWidth: 130,
    isResizable: false,
    onRender: (item) => item.last_match_date ? new Date(item.last_match_date).toLocaleDateString() : '—',
  },
]

const startDate = new Date(2010, 7)
const endDate = new Date()
const totalMonths = (endDate.getFullYear() - startDate.getFullYear()) * 12 + endDate.getMonth() - startDate.getMonth() + 1;

const History = () => {
  const [monthOffset, setMonthOffset] = useState(totalMonths - 1);
  const [loading, setLoading] = useState(false)
  const players = useSelector(selectPlayersHistory)
  const dispatch = useDispatch()
  const requestRef = useRef(0)

  const fetchHistory = useCallback(debounce((targetDate) => {
    const requestId = ++requestRef.current
    setLoading(true)
    dispatch(getPlayersHistory(targetDate.getTime())).then(() => {
      if (requestRef.current === requestId) setLoading(false)
    })
  }, 300), [dispatch])

  useEffect(() => {
    return () => fetchHistory.cancel()
  }, [fetchHistory])

  useEffect(() => {
    const targetDate = new Date(startDate)
    targetDate.setMonth(startDate.getMonth() + monthOffset)
    fetchHistory(targetDate)
  }, [fetchHistory, monthOffset, dispatch])

  const formatMonth = (value) => {
    const date = new Date(startDate);
    date.setMonth(startDate.getMonth() + value);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  return (
    <div className="matchList">
        <Slider
          label="Select Month and Year"
          min={0}
          max={totalMonths - 1}
          value={monthOffset}
          onChange={setMonthOffset}

          showValue
          valueFormat={formatMonth}
          styles={{ root: { margin: 20 } }}
        />
      {loading ? (
        <Spinner size={SpinnerSize.large} label="Loading rankings..." style={{ marginTop: 40 }} />
      ) : (
        <div className="matchTable" data-is-scrollable={true}>
          <div style={{ minWidth: 900 }}>
            <DetailsList
              items={players}
              columns={defaultColumns}
              getKey={(item) => item.id}
              setKey="none"
              selectionMode="none"
              checkboxVisibility={2}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default History
